export default "__VITE_ASSET__CXMz6wDy__"